import {
  ComponentFactoryResolver, Directive, EventEmitter, Input, OnInit,
  ViewContainerRef
} from "@angular/core";
import { FormGroup } from "@angular/forms";
import { FieldConfig } from "../../field.interface";
import { InputComponent } from "../input/input.component";
import { ButtonComponent } from "../button/button.component";
import { SelectComponent } from "../select/select.component";
import { DateComponent } from "../date/date.component";
import { RadiobuttonComponent } from "../radiobutton/radiobutton.component";
import { CheckboxComponent } from "../checkbox/checkbox.component";
import { AutocompleteComponent } from "../autocomplete/autocomplete.component";
import { EspacioEnBlancoComponent } from "../espacio-en-blanco/espacio-en-blanco.component";
import { SeparadorComponent } from "../separador/separador.component";
import { SpinnerComponent } from "../spinner/spinner.component";
import { OneToManyComponent } from "../one-to-many/components/one-to-many.component";
import { SubmitComponent } from "../submit/submit.component";
import { MultipleSelectComponent } from "../select-multiple/select-multiple.component";
import { FileUploaderComponent } from "../file-uploader/file-uploader.component";
import { SearchInputComponent } from "app/@theme/components";
import { TextAreaComponent } from "../text-area/text-area.component";
import { HistorialComponent } from "../historial/historial.component";

const componentMapper = {
  input: InputComponent,
  fileUploader: FileUploaderComponent,
  button: ButtonComponent,
  select: SelectComponent,
  date: DateComponent,
  radiobutton: RadiobuttonComponent,
  checkbox: CheckboxComponent,
  autocomplete: AutocompleteComponent,
  espacioEnBlanco: EspacioEnBlancoComponent,
  separador: SeparadorComponent,
  spinner: SpinnerComponent,
  submit: SubmitComponent,
  oneToMany: OneToManyComponent,
  multipleSelect: MultipleSelectComponent,
  search: SearchInputComponent,
  textArea: TextAreaComponent,
  historial: HistorialComponent
};

@Directive({
  selector: '[dynamicField]'
})
export class DynamicFieldDirective implements OnInit {
  @Input() field: FieldConfig;
  @Input() group: FormGroup;
  @Input() callback?: (args: any)=> void;
  componentRef: any;
  constructor(
    private resolver: ComponentFactoryResolver,
    private container: ViewContainerRef
  ) { }
  ngOnInit() {
    if (this.field) {
      const factory = this.resolver.resolveComponentFactory(
        componentMapper[this.field.type]
      );
      this.componentRef = this.container.createComponent(factory);
      this.componentRef.instance.field = this.field;
      this.componentRef.instance.group = this.group;
      this.componentRef.instance.callback = this.callback ? this.callback : null;
    }
  }
}

